const testimonials = [
  {
    quote:
      "I've done two coaching sessions with Binaifer, and both left me with what great coaching often does: questions that stay with you. Questions that quietly challenge your assumptions and help you find your own answers. If you're thinking about your career, life, relationships, or simply trying to understand yourself better, she's someone worth having a conversation with. I'm grateful for the space she holds.",
    name: "Vrudhi Desai",
  },
  {
    quote:
      "Helped me unlock where my head is at by asking the right questions. I appreciated the chance to pressure-test thoughts, and think intentionally about my growth. If you're in a place where you're seeking clarity and navigating what's next for you, it's worth making space for this.",
    name: "Tanya Bali",
  },
];

import { ArrowRight } from "lucide-react";

export default function Coaching() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="coaching"
      data-testid="coaching-section"
      className="relative py-28 md:py-36 bg-[#FAFAF8] border-t border-black/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20">
          <div className="lg:col-span-5 reveal">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#6B6B6B] mb-5 font-medium">
              02. Coaching for Professionals
            </div>
            <h2 className="font-display text-[#0A0A0A] text-[34px] sm:text-[44px] lg:text-[56px] font-medium leading-[1.06] tracking-[-0.025em]">
              Executive and Leadership Coach
            </h2>
          </div>

          <div className="lg:col-span-7 reveal">
            <div className="space-y-5 text-[16px] md:text-[18px] text-[#1F1F1F] leading-[1.7] font-normal max-w-2xl">
              <p>
                Coaching is a process that helps you discover your own answers,
                deepen self-awareness, and build clear action plans toward your
                goals and aspirations.
              </p>
              <p>
                One of my favourite parts of my work has always been witnessing
                the evolution of people, which is why I've been training with
                the International Coaching Federation to become a coach. I've
                completed 50+ pro bono coaching hours so far.
              </p>
              <p>
                My role is to listen deeply and ask thoughtful questions that
                help you move closer to what truly matters to you.
              </p>
              <p>
                Having experienced leadership coaching myself, I know how
                transformational it can be. It helped me understand what I was
                trying to prove, and to whom. It revealed hidden commitments I
                had carried for years that no longer served me. It surfaced
                behaviours I had long outgrown but was still holding onto. Most
                of all, it gave me momentum.
              </p>
              <p>
                My hope is that together, we can unlock that same clarity and
                momentum for you.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-24 md:mt-32">
          <div className="reveal text-[11px] uppercase tracking-[0.28em] text-[#6B6B6B] mb-10 font-medium">
            Testimonials from Coachees
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
            {testimonials.map((t, i) => (
              <figure
                key={i}
                data-testid={`testimonial-${i}`}
                className="reveal"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <blockquote className="font-display text-[#0A0A0A] text-[20px] sm:text-[22px] md:text-[24px] font-light leading-[1.45] tracking-[-0.012em]">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-10 pt-6 border-t border-black/10 text-[12px] uppercase tracking-[0.22em] text-[#6B6B6B] font-medium">
                  {t.name}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>

        <div className="reveal mt-20 md:mt-24">
          <button
            data-testid="coaching-cta-discovery"
            onClick={() => scrollTo("#booking")}
            className="group inline-flex items-center gap-2 rounded-full bg-[#0A0A0A] hover:bg-[#1F1F1F] text-white px-7 py-3.5 text-[14px] font-medium transition-all duration-300"
          >
            Book a discovery call
            <ArrowRight
              size={15}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </button>
        </div>
      </div>
    </section>
  );
}
